Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "gmailTabsStyles", {
    enumerable: true,
    get: function get() {
        return _gmailTabs.tabsStyles;
    }
});
Object.defineProperty(exports, "gmailTabItemStyles", {
    enumerable: true,
    get: function get() {
        return _gmailTabs.tabItemStyles;
    }
});
exports.useGmailTabItemStyles = exports.useGmailTabsStyles = void 0;

var _styles = require("@material-ui/styles");

var _gmailTabs = require("./gmailTabsStyle");

var useGmailTabsStyles = (0, _styles.makeStyles)(_gmailTabs.tabsStyles);
exports.useGmailTabsStyles = useGmailTabsStyles;
var useGmailTabItemStyles = (0, _styles.makeStyles)(_gmailTabs.tabItemStyles);
exports.useGmailTabItemStyles = useGmailTabItemStyles;